import { render, staticRenderFns } from "./Monteria.vue?vue&type=template&id=09940ce2"
import script from "./Monteria.vue?vue&type=script&lang=js"
export * from "./Monteria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports